import { jsx as c } from "react/jsx-runtime";
import { Icon as a } from "../../../../components/Icon/index.js";
import { ToolbarButton as s } from "../../styles.js";
import { useQuillActiveFormat as b } from "../../hooks/useQuillActiveFormat/index.js";
import { Bold as d, Italic as p, Strikethrough as h } from "@pelando/fontawesome/icons";
import { useTranslation as k } from "../../../../hooks/useTranslation/index.js";
const f = (t) => ({
  bold: d,
  italic: p,
  strike: h
})[t], i = (t) => ({
  bold: "format-button-bold",
  italic: "format-button-italic",
  strike: "format-button-strike"
})[t];
function v({ quill: t, format: o }) {
  const { t: r } = k("common"), m = b(t);
  return /* @__PURE__ */ c(
    s,
    {
      type: "button",
      onClick: () => {
        const n = t == null ? void 0 : t.getSelection(), e = t == null ? void 0 : t.getFormat({
          index: (n == null ? void 0 : n.index) || 0,
          length: (n == null ? void 0 : n.length) || 0
        });
        t == null || t.format(o, !(e != null && e[o]));
      },
      title: r(i(o)),
      "aria-pressed": !!m[o],
      children: /* @__PURE__ */ c(
        a,
        {
          icon: f(o),
          "aria-label": r(i(o))
        }
      )
    }
  );
}
export {
  v as FormatButton
};
